









































































import { defineComponent, ref, useFetch } from "@nuxtjs/composition-api";
import { useLicensePlateRegistration } from "../composables/useLicensePlateRegistration";
import type { LicensePlate } from "../composables/useLicensePlateRegistration";
import { SfTabs } from "@storefront-ui/vue";
import SkeletonLoader from "components/theme/SkeletonLoader.vue";
import RegisteredPlate from "../components/RegisteredPlate.vue";
import { SfButton, SfNotification } from "@storefront-ui/vue";
import type { KjoretoydataListe } from "../composables/useLicensePlateFinder/types";

import { SfOverlay } from "@storefront-ui/vue";

export default defineComponent({
  name: "FindMyTractor",
  components: {
    SfTabs,
    SkeletonLoader,
    RegisteredPlate,
    SfButton,
    SfNotification,
    LicensePlateRegistrationModal: () =>
      import("../components/LicensePlateRegistrationModal.vue"),
    LicensePlateInformationModal: () =>
      import("../components/LicensePlateInformationModal.vue"),
    SfOverlay,
  },
  setup() {
    const currentPlate = ref<LicensePlate | null>(null);
    const isRemoving = ref<LicensePlate | null>(null);
    const isDetailsVisible = ref(false);
    const showRegistration = ref(false);
    const licensePlates = ref<LicensePlate[]>([]);
    const { loading, getRegisteredPlates, registerPlate, removePlate } =
      useLicensePlateRegistration();

    useFetch(async () => {
      const plates = await getRegisteredPlates();
      licensePlates.value = plates;
    });

    async function addLicensePlate({
      brand,
      model,
      information,
      licensePlate,
    }: {
      brand: string | null;
      model: string | null;
      information: KjoretoydataListe;
      licensePlate: string;
    }) {
      const compareStr = licensePlate.replace(/\s/g, "").toLowerCase();
      const existingPlate = licensePlates.value.find(
        (plate) =>
          plate.license_plate.replace(/\s/g, "").toLowerCase() === compareStr
      );
      if (existingPlate) {
        return;
      }
      const plate = await registerPlate({
        license_plate: licensePlate,
        brand,
        model,
        info: JSON.stringify(information),
      });
      if (plate) {
        licensePlates.value.push(plate);
      }
      showRegistration.value = false;
    }

    async function removeAssignedPlate(plate: LicensePlate) {
      await removePlate(plate.uid);
      licensePlates.value = licensePlates.value.filter(
        (oldplate) => oldplate.uid !== plate.uid
      );
      isRemoving.value = null;
      currentPlate.value = null;
    }

    function showRemoveConfirmation(plate: LicensePlate) {
      currentPlate.value = plate;
      isRemoving.value = plate;
    }

    function showDetails(plate: LicensePlate) {
      currentPlate.value = plate;
      isDetailsVisible.value = true;
    }

    return {
      showRegistration,
      loading,
      licensePlates,
      addLicensePlate,
      currentPlate,
      isRemoving,
      isDetailsVisible,
      showRemoveConfirmation,
      showDetails,
      removeAssignedPlate,
    };
  },
});
